module.exports = __webpack_public_path__ + "static/media/inventario_icon.c156426d.png";